import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Breadcrumbs, RouteLayout } from '@web/app/components'
import { FileText } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/documents')({
  component: RouteComponent,
  staticData: {
    metaRoute: {
      title: 'Documentos',
      icon: FileText
    },
  },
})

function RouteComponent() {
  return (
    <RouteLayout>
      <Breadcrumbs basePath={Route.fullPath} fd={'row'} ai={'center'} gap={'$1'} mb={'$true'} />
      <Outlet />
    </RouteLayout>
  )
}
